import Icon from "@ant-design/icons";
import {Image} from "antd";
import {
	LowesIconImg
} from "../../../../assets";


export const MyIcon = (props) => <Image src={LowesIconImg} preview={false}/>
